import { getRemoteValueEnv } from "../../../../setup";
import { defaultCatalogoCopys } from "./componentConstants";

const getTagColor = (name) => {
  switch (name) {
    case "Integral":
      return {
        textColor: "#FFFFFF",
        backgroundColor: "#5451fb",
        fontWeight: "400",
      };
    case "Paga Metade":
      return {
        textColor: "#FFFFFF",
        backgroundColor: "#EB7831",
        fontWeight: "400",
      };
    case "Paga Reduzida":
      return {
        textColor: "#000000",
        backgroundColor: "#F6DD64",
        fontWeight: "500",
      };
    default:
      return {
        textColor: "#FFFFFF",
        backgroundColor: "#474747",
        fontWeight: "400",
      };
  }
};

const getCardText = (name) => {
  const catalogCopys = JSON.parse(
    getRemoteValueEnv("general_copys_dev", "general_copys_prod").asString()
  );

  switch (name) {
    case "Paga Metade":
      return catalogCopys.catalogo_pagametade
        ? catalogCopys.catalogo_pagametade
        : defaultCatalogoCopys.catalogo_pagametade;
    case "Paga Reduzida":
      return catalogCopys.catalogo_reduzida
        ? catalogCopys.catalogo_reduzida
        : defaultCatalogoCopys.catalogo_reduzida;
    case "Integral":
    default:
      return catalogCopys.catalogo_integral
        ? catalogCopys.catalogo_integral
        : defaultCatalogoCopys.catalogo_integral;
  }
};

const getTagText = (name) => {
  switch (name) {
    case "Integral":
      return "Integral";
    case "Paga Metade":
      return "Paga Metade";
    case "Paga Reduzida":
      return "Parcela reduzida em 30%";
    default:
      return "Integral";
  }
};

export { getCardText, getTagColor, getTagText };
